import { render, staticRenderFns } from "./VodPlayerNew.vue?vue&type=template&id=cf3d5b06&scoped=true&"
import script from "./VodPlayerNew.vue?vue&type=script&lang=js&"
export * from "./VodPlayerNew.vue?vue&type=script&lang=js&"
import style0 from "./VodPlayerNew.vue?vue&type=style&index=0&id=cf3d5b06&scoped=true&lang=css&"
import style1 from "./VodPlayerNew.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3d5b06",
  null
  
)

export default component.exports